
import { useTranslation } from 'react-i18next';

export default function ServicesSection() {
  const { t } = useTranslation();
  
  const services = [
    {
      icon: 'ri-search-line',
      title: t('brandSourcing'),
      description: t('brandSourcingDesc')
    },
    {
      icon: 'ri-truck-line',
      title: t('supplyChain'),
      description: t('supplyChainDesc')
    },
    {
      icon: 'ri-global-line',
      title: t('marketEntry'),
      description: t('marketEntryDesc')
    },
    {
      icon: 'ri-store-line',
      title: t('retailNetwork'),
      description: t('retailNetworkDesc')
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black" style={{ fontFamily: 'Playfair Display, serif' }}>
            {t('ourServices')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('servicesDescription')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="text-center group hover:transform hover:scale-105 transition-all duration-300">
              <div className="w-20 h-20 mx-auto mb-6 bg-black text-white rounded-full flex items-center justify-center group-hover:bg-amber-600 transition-colors duration-300">
                <i className={`${service.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold mb-4 text-black">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
